import React, { useCallback, useEffect, useState } from 'react';
import {
  ProSidebar,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';
import { getActiveItemData } from './buildingsService';
import { INTRODUCTION_HTML } from './constants';

const Aside = ({ activeItem, collapsed, toggled, handleToggleSidebar }) => {
  const [activeItemDescription, setActiveItemDescription] =
    useState(INTRODUCTION_HTML);
  const [activeItemName, setActiveItemName] = useState(null);
  const [activeItemUrl, setActiveItemUrl] = useState(null);
  const [activeItemAddress, setActiveItemAddress] = useState(null);

  useEffect(() => {
    if (!activeItem?.nid) return;
    getActiveItemData({
      nid: activeItem?.nid,
    }).then((item) => {
      setActiveItemName(item.name);
      setActiveItemDescription(item.description);
      setActiveItemUrl(item.url);
      setActiveItemAddress(item.address);
      document.querySelector('.pro-sidebar-layout').scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }, [activeItem]);

  const handleTitleClick = useCallback(() => {
    setActiveItemName(null);
    setActiveItemDescription(INTRODUCTION_HTML);
    setActiveItemUrl(null);
    setActiveItemAddress(null);
  });

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      breakPoint="md"
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader>
        <div className="project-title" onClick={handleTitleClick}>
          ПЕТРОВСКИЕ ПАМЯТНИКИ МОСКВЫ
        </div>
      </SidebarHeader>

      <SidebarContent>
        <h4 className="item-name">{activeItemName}</h4>
        <h4 className="item-address">{activeItemAddress}</h4>
        <div
          className="item-description"
          dangerouslySetInnerHTML={{ __html: activeItemDescription }}
        />
        <div className="item-url">
          {activeItemUrl && (
            <a className="item-link" href={activeItemUrl} target="_blank">
              Полный текст и иллюстрации см. на сайте "Свод петровских
              памятников России и Европы"
            </a>
          )}
        </div>
      </SidebarContent>
      <SidebarFooter></SidebarFooter>
    </ProSidebar>
  );
};

export default Aside;
